
const analyticsTypes = {
  HOME_DELIVERY_PAGE_VIEW: 'hd__pageview',
  HOME_DELIVERY_FORM_START: 'hd__formstart',
  HOME_DELIVERY_BANNER_VIEW: 'hd__bannerview'
};


const analyticsActions = [{
  type: analyticsTypes.HOME_DELIVERY_PAGE_VIEW
}, {
  type: analyticsTypes.HOME_DELIVERY_FORM_START
}, {
  type: analyticsTypes.HOME_DELIVERY_BANNER_VIEW
}];

export {
  analyticsTypes,
  analyticsActions
};
